import React from 'react';
import { FileText, Plus } from 'lucide-react';

const DocumentsTab = ({ projectDocuments }) => {
  return (
    <div className="bg-white border border-zinc-200 p-4 sm:p-6  mb-6">
      <div className="flex items-center justify-between mb-4">
        <h3 className="font-heading text-lg font-bold uppercase tracking-wide">Project Documents</h3>
        <button
          onClick={() => window.location.href = '/inbox'}
          data-testid="go-to-inbox-btn"
          className="h-10 px-4 bg-primary text-zinc-900 font-bold uppercase text-xs border border-zinc-200 hover:bg-primary-hover flex items-center gap-2"
        >
          <Plus className="w-4 h-4" />
          Add from Inbox
        </button>
      </div>
      {projectDocuments.length === 0 ? (
        <div className="text-center py-8" data-testid="project-docs-empty">
          <FileText className="w-12 h-12 mx-auto mb-3 text-zinc-500" />
          <p className="font-bold mb-1">No documents assigned</p>
          <p className="text-sm text-zinc-500">
            Upload documents in the Inbox and assign them to this project.
          </p>
        </div>
      ) : (
        <div className="space-y-2">
          {projectDocuments.map((doc) => (
            <button
              key={doc.document_id}
              onClick={() => window.location.href = `/inbox/${doc.document_id}`}
              data-testid={`project-doc-${doc.document_id}`}
              className="w-full flex items-center gap-3 p-3 border border-zinc-200 bg-zinc-50 hover:bg-zinc-50 text-left transition-colors"
            >
              <div className={`w-8 h-8 border border-black flex items-center justify-center flex-shrink-0 ${
                doc.status === 'New' ? 'bg-primary' : 'bg-zinc-50'
              }`}>
                <FileText className="w-4 h-4" />
              </div>
              <div className="flex-1 min-w-0">
                <p className="font-bold text-sm truncate">{doc.title}</p>
                <div className="flex items-center gap-2 mt-0.5">
                  <span className={`px-1.5 py-0.5 text-xs font-bold uppercase border border-black ${
                    doc.document_type === 'Quote' ? 'bg-blue-500 text-white' :
                    doc.document_type === 'Invoice' ? 'bg-purple-500 text-white' :
                    doc.document_type === 'Order Confirmation' ? 'bg-green-500 text-white' :
                    doc.document_type === 'Packing Slip' ? 'bg-orange-500 text-zinc-900' : 'bg-zinc-500 text-white'
                  }`}>
                    {doc.document_type}
                  </span>
                  <span className={`px-1.5 py-0.5 text-xs font-bold uppercase border border-black ${
                    doc.status === 'New' ? 'bg-primary text-zinc-900' :
                    doc.status === 'Reviewed' ? 'bg-blue-500 text-white' : 'bg-green-500 text-white'
                  }`}>
                    {doc.status}
                  </span>
                  {doc.sender && <span className="text-xs text-zinc-500">{doc.sender}</span>}
                </div>
              </div>
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default DocumentsTab;
